import { useDebouncedValue } from "@mantine/hooks"
import { useEffect } from "react"

export const useDebouncedFunctionWithValue = <T>(func: (value: T) => void, value: T, debounceTime: number) => {
    const [debouncedValue] = useDebouncedValue(value, debounceTime)

    useEffect(() => {
        func(debouncedValue)
    }, [debouncedValue, func])

    return debouncedValue
}
